import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import EmpresaPessoaApp from '../EmpresaPessoa/EmpresaPessoaApp';

class EmpresaClienteApp extends XAPPComponent {

    render() {
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <EmpresaPessoaApp
                    xappRouteParams={xappRouteParams}
                    isGestor={false}
                    label={`${this.getDicionario("cliente", "cliente")}s`}
                    target="spvwempresapessoacliente"
                    {...this.props}
                    defaultTipo={[3]}
                />
            </React.Fragment>
        )
    };
}


export default EmpresaClienteApp;
